export class FleetPainByFleetAtaChapter {
  id: number;
  pain_index_month: Date;
  rank: number;
  fleet_rank: number;
  ata_chapter_rank: number;
  fleet_cd: string;
  ata_chapter: string;
  ata_chapter_desc: string;
  pain_sum: number;
  pain_tos_delay_cost: number;
  tos_delay_cost_rank: number;
  pain_delay_cost: number;
  delay_cost_rank: number;
  fleet_delay_rank: number;
  ata_chapter_delay_rank: number;
  pain_sig_event_cost: number;
  sig_event_cost_rank: number;
  fleet_sig_event_rank: number;
  ata_chapter_sig_event_rank: number;
  pain_atb_cost: number;
  atb_cost_rank: number;
  fleet_atb_rank: number;
  ata_chapter_atb_rank: number;
  pain_div_cost: number;
  div_cost_rank: number;
  fleet_div_rank: number;
  ata_chapter_div_rank: number;
  pain_rto_cost: number;
  rto_cost_rank: number;
  fleet_rto_rank: number;
  ata_chapter_rto_rank: number;
  pain_ifsd_cost: number;
  ifsd_cost_rank: number;
  fleet_ifsd_rank: number;
  ata_chapter_ifsd_rank: number;
  pain_emer_cost: number;
  emer_cost_rank: number;
  fleet_emer_rank: number;
  ata_chapter_emer_rank: number;
  pain_oos_event_cost: number;
  oos_cost_rank: number;
  fleet_oos_rank: number;
  ata_chapter_oos_rank: number;
  pain_pdis_cost: number;
  pdis_cost_rank: number;
  fleet_pdis_rank: number;
  ata_chapter_pdis_rank: number;
  pain_wdl_cost: number;
  wdl_cost_rank: number;
  fleet_wdl_rank: number;
  ata_chapter_wdl_rank: number;
  pain_rdl_cost: number;
  rdl_cost_rank: number;
  fleet_rdl_rank: number;
  ata_chapter_rdl_rank: number;
  m2_count: number;
  m2_count_rank: number;
  fleet_m2_count_rank: number;
  ata_chapter_m2_count_rank: number;
  m2_dly_count: number;
  m2_dly_count_rank: number;
  fleet_m2_dly_count_rank: number;
  ata_chapter_m2_dly_count_rank: number;
  m2_cnl_count: number;
  m2_cnl_count_rank: number;
  fleet_m2_cnl_count_rank: number;
  ata_chapter_m2_cnl_count_rank: number;
  div_count: number;
  div_count_rank: number;
  fleet_div_count_rank: number;
  ata_chapter_div_count_rank: number;
  rto_count: number;
  rto_count_rank: number;
  fleet_rto_count_rank: number;
  ata_chapter_rto_count_rank: number;
  ifsd_count: number;
  ifsd_count_rank: number;
  fleet_ifsd_count_rank: number;
  ata_chapter_ifsd_count_rank: number;
  atb_count: number;
  atb_count_rank: number;
  fleet_atb_count_rank: number;
  ata_chapter_atb_count_rank: number;
  btb_count: number;
  btb_count_rank: number;
  fleet_btb_count_rank: number;
  ata_chapter_btb_count_rank: number;
  othr_count: number;
  othr_count_rank: number;
  fleet_othr_count_rank: number;
  ata_chapter_othr_count_rank: number;
  smk_count: number;
  smk_count_rank: number;
  fleet_smk_count_rank: number;
  ata_chapter_smk_count_rank: number;
  damage_count: number;
  damage_count_rank: number;
  fleet_damage_count_rank: number;
  ata_chapter_damage_count_rank: number;
  swapped_ac_count: number;
  swapped_ac_count_rank: number;
  fleet_swapped_ac_count_rank: number;
  ata_chapter_swapped_ac_count_rank: number;
  tfoa_count: number;
  tfoa_count_rank: number;
  fleet_tfoa_count_rank: number;
  ata_chapter_tfoa_count_rank: number;
  emer_count: number;
  emer_count_rank: number;
  fleet_emer_count_rank: number;
  ata_chapter_emer_count_rank: number;
  oos_event_count: number;
  oos_event_count_rank: number;
  fleet_oos_event_count_rank: number;
  ata_chapter_oos_event_count_rank: number;
  wdl_count: number;
  wdl_count_rank: number;
  fleet_wdl_count_rank: number;
  ata_chapter_wdl_count_rank: number;
  rdl_count: number;
  rdl_count_rank: number;
  fleet_rdl_count_rank: number;
  ata_chapter_rdl_count_rank: number;
  total_m2_dly_minutes: number;
  total_m2_dly_minutes_rank: number;
  fleet_total_m2_dly_minutes_rank: number;
  ata_chapter_total_m2_dly_minutes_rank: number;
  avg_m2_dly_minutes: number;
  avg_m2_dly_minutes_rank: number;
  fleet_avg_m2_dly_minutes_rank: number;
  ata_chapter_avg_m2_dly_minutes_rank: number;
  m2_dly_30_min_count: number;
  m2_dly_30_min_count_rank: number;
  fleet_m2_dly_30_min_count_rank: number;
  ata_chapter_m2_dly_30_min_count_rank: number;
  mel_count: number;
  mel_count_rank: number;
  fleet_mel_count_rank: number;
  ata_chapter_mel_count_rank: number;
  pain_oos_direct_cost: number;
  oos_direct_cost_rank: number;
  fleet_oos_direct_rank: number;
  ata_chapter_oos_direct_rank: number;
  pain_oos_indirect_cost: number;
  oos_indirect_cost_rank: number;
  fleet_oos_indirect_rank: number;
  ata_chapter_oos_indirect_rank: number;
  oos_event_min: number;
  oos_event_min_rank: number;
  fleet_oos_event_min_rank: number;
  ata_chapter_oos_event_min_rank: number;
  oos_event_hrs: number;
  oos_event_hrs_rank: number;
  fleet_oos_event_hrs_rank: number;
  ata_chapter_oos_event_hrs_rank: number;
  pain_fuel_penalty_cost: number;
  fuel_penalty_cost_rank: number;
  rank_prev1mo: number;
  rank_change_prev1mo: number;
  rank_prev3mo: number;
  rank_change_prev3mo: number;
  rank_prev6mo: number;
  rank_change_prev6mo: number;
  rank_prev12mo: number;
  rank_change_prev12mo: number;
  rank_prev36mo: number;
  rank_change_prev36mo: number;
}
